<template>
  <div :class="['project-detail',details.nqiType === '计量'?'bg1':'',details.nqiType === '标准'?'bg2':'',details.nqiType === '检验检测'?'bg3':'',details.nqiType === '认证认可'?'bg4':'',details.nqiType === '典型示范'?'bg5':'']">
    <div class="body-content">
      <div class="breadcrumb-box">
        <div class="breadcrumb-body">
          <span class="pointer" @click="toHome">首页</span>
          <span>>></span>
          <span class="pointer" @click="toPath('/bright?tab='+nqiType)">{{nqiType}}</span>
          <span>>></span>
          <span>详情</span>
        </div>
      </div>
      <div v-if="details.nqiType === '计量'">
        <h2>{{title}}</h2>
        <div class="case" style="margin-bottom: 64px;">
          <div class="title">
            <div class="title-zi">亮点成果</div>
          </div>
          <div class="bright-title">「&nbsp;{{details.brightTitle}}&nbsp;」</div>
          <div class="line"></div>
          <div class="content" v-html="brightContent" style="margin-bottom: 24px;">
          </div>
          <div style="width: 100%;display: flex;justify-content: center;">
            <div class="img" v-for="(item,index) in brightImages" :key="index">
              <img v-if="details.brightImage" class="pic" :src="fileUrl +　item" alt="">
            </div>
          </div>
          <div class="img-title" v-if="details.brightImageTitle">
            {{details.brightImageTitle}}
          </div>
        </div>
        <div class="case" style="margin-bottom: 80px;">
          <div class="title">
            <div class="title-zi">应用成效</div>
          </div>
          <div class="bright-title">「&nbsp;{{details.applyResultTitle}}&nbsp;」</div>
          <div class="line"></div>
          <div class="content" v-html="details.applyResultContent">
          </div>
          <div style="width: 100%;display: flex;justify-content: center;">
            <div class="img" v-for="(item,index) in applyResultImages" :key="index">
              <img v-if="details.applyResultImage" class="pic" :src="fileUrl +　item" alt="">
            </div>
          </div>
          <div class="img-title" v-if="details.applyResultImageTitle">
            {{details.applyResultImageTitle}}
          </div>
        </div>
      </div>

      <div v-if="details.nqiType === '标准'">
        <h2>{{title}}</h2>
        <div class="case2" style="margin-bottom: 64px;">
          <div class="background-headline">
            亮点成果
          </div>
          <div class="case2-title">
            {{details.brightTitle}}
          </div>
          <div class="case2-content"  v-html="brightContent">
          </div>
          <div class="case2-img2">
            <div style="display: flex;justify-content: center;">
              <div class="case2-tu" v-for="(item,index) in brightImages" :key="index">
                <img v-if="details.brightImage" :src="fileUrl +　item" alt="">
              </div>
            </div>
            <div calss="case2-pictit" v-if="details.brightImageTitle">{{details.brightImageTitle}}</div>
          </div>
        </div>
        <div class="case2" style="margin-bottom: 80px;">
          <div class="background-headline">
            应用成效
          </div>
          <div class="case2-title">
            {{details.applyResultTitle}}
          </div>
          <div class="case2-content" v-html="details.applyResultContent">
          </div>
          <div class="case2-img2">
            <div style="display: flex;justify-content: center;">
              <div class="case2-tu" v-for="(item,index) in applyResultImages" :key="index">
                <img v-if="details.applyResultImage" :src="fileUrl +　item" alt="">
              </div>
            </div>
            <div calss="case2-pictit" v-if="details.applyResultImageTitle">{{details.applyResultImageTitle}}</div>
          </div>
        </div>
      </div>

      <div v-if="details.nqiType === '检验检测'">
        <h2>{{title}}</h2>
        <div class="case3">
          <div class="title">
            <div class="title-zi">亮点成果</div>
            <div class="title-tit">
              {{details.brightTitle}}
            </div>
          </div>
          <div class="line"></div>
          <div class="content">
            <div class="content-text"  v-html="brightContent"></div>
            <div style="width: 560px;">
              <div class="content-img">
              <div class="img" style="display: flex;justify-content: center;">
                <div v-for="(item,index) in brightImages" :key="index" style="width: 171px;height: 240px;margin-right: 17px;margin-top: 40px;">
                  <img v-if="details.brightImage" :src="fileUrl +　item" alt="">
                </div>
                <div class="title" v-if="details.brightImageTitle">
                  <div class="text">{{details.brightImageTitle}}</div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>

        <div class="case3" style="margin-bottom: 80px;">
          <div class="title">
            <div class="title-zi">应用成效</div>
            <div class="title-tit">
              {{details.applyResultTitle}}
            </div>
          </div>
          <div class="line"></div>
          <div class="content">
            <div class="content-text"  v-html="details.applyResultContent">
            </div>
            <div :class="['content-img',details.applyResultImage?'border':'']">
              <div class="img" style="display: flex;justify-content: center;">
                <div v-for="(item,index) in applyResultImages" :key="index" style="width: 171px;height: 240px;margin-right: 17px;margin-top: 40px;">
                  <img v-if="details.applyResultImage" :src="fileUrl +　item" alt="">
                </div>
                <div class="title" v-if="details.applyResultImageTitle">
                <div class="text">{{details.applyResultImageTitle}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="details.nqiType === '认证认可'">
        <h2>{{title}}</h2>
        <div class="case4" style="margin-bottom:80px;">
          <div class="left">
            <div class="title">
              <div class="title-zi">亮点成果</div>
            </div>
            <div class="content">
              <div class="content-title">{{details.brightTitle}}</div>
              <div class="content-text"  v-html="brightContent"></div>
              <div style="width: 100%;height: 326px;background: #FFFFFF;display: flex;justify-content: center;">
                <div class="content-img" v-for="(item,index) in brightImages" :key="index">
                  <img v-if="details.brightImage" :src="fileUrl +　item" alt="">
                </div>
              </div>
              <div class="img-title" v-if="details.brightImageTitle">{{details.brightImageTitle}}</div>
            </div>
          </div>
          <div class="left">
            <div class="title">
              <div class="title-zi">应用成效</div>
            </div>
            <div class="content">
              <div class="content-title">{{details.applyResultTitle}}</div>
              <div class="content-text"  v-html="details.applyResultContent"></div>
              <div style="width: 100%;background: #FFFFFF;height: 326px;display: flex;justify-content: center;">
                <div class="content-img" v-for="(item,index) in applyResultImages" :key="index">
                  <img v-if="details.applyResultImage" :src="fileUrl +　item" alt="">
                </div>
              </div>
              <div class="img-title" v-if="details.applyResultImageTitle">{{details.applyResultImageTitle}}</div>
            </div>
          </div>

        </div>
      </div>

      <div v-if="details.nqiType === '典型示范'">
        <h2>{{title}}</h2>
        <div class="case5">
          <div class="title">
            <div class="title-zi">亮点成果</div>
          </div>
          <div class="line"></div>
          <div class="content">
            <div class="left">
              <div class="content-title">{{details.brightTitle}}</div>
              <div class="content-text" v-html="brightContent"></div>
            </div>
            <div class="right">
              <div>
                <div class="content-img" v-for="(item,index) in brightImages" :key="index">
                  <img v-if="details.brightImage" :src="fileUrl +　item" alt="">
                </div>
              </div>
              <div class="img-title" v-if="details.brightImageTitle">{{details.brightImageTitle}}</div>
            </div>
          </div>
        </div>
        <div class="case5" style="margin-bottom:80px;">
          <div class="title">
            <div class="title-zi">应用成效</div>
          </div>
          <div class="line"></div>
          <div class="content">
            <div class="left">
              <div class="content-title">{{details.applyResultTitle}}</div>
              <div class="content-text" v-html="details.applyResultContent"></div>
            </div>
            <div class="right">
              <div>
                <div class="content-img" v-for="(item,index) in applyResultImages" :key="index">
                  <img v-if="details.applyResultImage" :src="fileUrl +　item" alt="">
                </div>
              </div>
              <div class="img-title" v-if="details.applyResultImageTitle">{{details.applyResultImageTitle}}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      details: [],
      nqiType: '',
      title: '',
      brightContent: '',
      fileUrl: 'http://172.172.1.100:90/dataapi/sys/common/static/',
      applyResultImages: [],
      brightImages: []
    }
  },
  created () {
    // console.log(this.$route.query.item)
    this.fetDetails()
  },
  methods: {
    toHome () {
      this.$router.push('/')
    },
    toPath (path) {
      this.$router.push(path)
    },
    fetDetails () {
      this.fetch('/dataapi/open/nqi/dataBright/queryById', {id: this.$route.query.id}).then(res => {
        // console.log(res)
        this.details = res.result;
        this.applyResultImages = res.result.applyResultImage.split(',');
        console.log(this.applyResultImages)
        this.brightImages = res.result.brightImage.split(',');
        this.title = res.result.title;
        this.nqiType = res.result.nqiType;
        this.brightContent = res.result.brightContent;
      })
    }
  }
}
</script>

<style lang="less" scoped >
.body-content {
  display: flex;
  width: @body-width;
  margin: 0 auto;
  flex-flow: column;
}
.bg1{
  background-image: url("../../assets/images/jl.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.bg2{
  background-image: url("../../assets/images/bz.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.bg3{
  background-image: url("../../assets/images/jy.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.bg4{
  background-image: url("../../assets/images/rz.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.bg5{
  background-image: url("../../assets/images/dx.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.breadcrumb-box {
  margin-bottom: 10px;
  padding-top: 12px;

  .breadcrumb-body {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 17px;

    span {
      margin-right: 7px;
    }
  }
}
.project-detail {
  min-height: 450px;
  .body-content{
      h2 {
        font-size: 32px;
        text-align: center;
        font-weight: bold;
        margin: 50px;
        line-height: 50px;
        color: rgba(0, 0, 0, 0.85);
      }
    .case{
      width: 1160px;
      margin: 0 auto;
      .title{
        width: 116px;
        height: 32px;
        background: #136BAE;
        display: flex;
        justify-content: center;
        margin: 0 auto;
        .title-zi{
          width: 84px;
          height: 29px;
          font-size: 21px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 29px;
        }
      }
      .bright-title{
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
        line-height: 25px;
        margin: 24px auto;
        text-align: center;
      }
      .line{
        width: 1160px;
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
        margin-bottom: 24px;
      }
      .content{
        margin: 0 auto;
        text-indent:2em;
        width: 1160px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
        letter-spacing: 1px;
      }
      .img{
        margin-right: 40px;
        width: 386px;
        height: 426px;
        .pic{
          width: 386px;
          max-width: 580px;
          height: 426px;
        }
      }
      .img-title{
        margin-top: 16px;
        text-align: center;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 25px;
      }
    }
    .case2{
      width: 1160px;
      margin: 0 auto;
      .background-headline{
        margin: 20px 0 26px 0;
        padding-left: 10px;
        line-height: 26px;
        font-weight: 600;
        font-size: 18px;
        border-left: 6px solid @color-base;
      }
      .case2-title{
        margin-bottom: 8px;
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
        line-height: 25px;
      }
      .case2-content{
        text-indent:2em;
        margin: 0 auto;
        width: 1160px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
        letter-spacing: 1px;
        margin-bottom: 34px;
      }
      .case2-img2{
        margin: 0 auto;
        text-align: center;
        width: 100%;
        .case2-tu{
          margin-bottom: 16px;
          margin-right: 40px;
          img{
            width: 386px;
            max-width: 580px;
            height: 424px;
          }
        }
      }
    }
    .case3{
      width: 1160px;
      margin: 0 auto;
      .border{
        border: 1px solid rgba(0, 0, 0, 0.1);
        background: #FFFFFF;
      }
      .title{
        display: flex;
        align-items: center;
        .title-zi{
          background: #136BAE;
          text-align: center;
          width: 116px;
          height: 32px;
          font-size: 21px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 32px;
        }
        .title-tit{
          width: 800px;
          height: 25px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.85);
          line-height: 25px;
          margin-left: 16px;
        }
      }
      .line{
        width: 1160px;
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
        margin: 19px 0 16px 0;
      }
      .content{
        display: flex;
        justify-content: space-between;
        margin-bottom: 94px;
        .content-text{
          text-indent:2em;
          width: 552px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555050;
          line-height: 28px;
          letter-spacing: 1px;
        }
        .content-img{
          width: 560px;
          height: 340px;
          position: relative;
          .img{
            img{
              width: 171px;
              height: 240px;
            }
            .title{
              position: absolute;
              bottom: 0;
              left: 0;
              width: 560px;
              height: 36px;
              background: rgba(0, 0, 0, 0.6);
              .text{
                text-align: center;
                height: 25px;
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #F6F7FB;
                line-height: 25px;
                margin: 0 auto;
              }
            }
          }
        }
      }
    }
    .case4{
      width: 1160px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .left{
        width: 540px;
        .title{
          width: 116px;
          height: 32px;
          background: #136BAE;
          display: flex;
          justify-content: center;
          .title-zi{
            width: 84px;
            height: 29px;
            font-size: 21px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 29px;
          }
        }
        .content{
          .content-title{
            margin-top: 24px;
            margin-bottom: 8px;
            width: 500px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.85);
            line-height: 25px;
          }
          .content-text{
            text-indent:2em;
            width: 540px;
            margin-bottom: 16px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #575151;
            line-height: 28px;
            letter-spacing: 1px;
          }
          .content-img{
            width: 273px;
            height: 198px;
            margin-top: 57px;
            margin-right: 10px;
            img{
              width: 273px;
              height: 198px;
            }
          }
          .img-title{
            margin-top: 16px;
            margin-bottom: 80px;
            width: 540px;
            text-align: center;
            height: 25px;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 25px;
          }
        }
      }
    }
    .case5{
      width: 1160px;
      margin: 0 auto;
      .title{
        width: 116px;
        height: 32px;
        background: #136BAE;
        display: flex;
        justify-content: center;
        .title-zi{
          width: 84px;
          height: 29px;
          font-size: 21px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 29px;
        }
      }
      .line{
        width: 480px;
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
        margin: 16px 0;
      }
      .content{
        margin-bottom: 32px;
        display: flex;
        justify-content: space-between;
        .left{
          .content-title{
            margin-bottom: 8px;
            width: 480px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: rgba(0, 0, 0, 0.85);
            line-height: 25px;
          }
          .content-text{
            text-indent:2em;
            width: 480px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #3E1B05;
            line-height: 28px;
            letter-spacing: 1px;
          }
        }
        .right{
          .content-img{
            margin-bottom: 16px;
            img{
              width: 632px;
              height: 298px;
            }
          }
          .img-title{
            margin-top: 24px;
            text-align: center;
            width: 632px;
            height: 25px;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 25px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/brightDetail/index.vue